<template>
    <el-dialog
        custom-class="custom-dialog"
        :visible="true"
        width="750px"
        :lock-scroll="false"
        :append-to-body="true"
        @close="handleCancel"
        :fullscreen="fullscreen"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
        <template #title>
            <span>{{ form.id === 0 ? '添加分组' : '编辑分组' }}</span>
            <i
                class="full-screen"
                :class="[fullscreen ? 'el-icon-crop' : 'el-icon-full-screen']"
                @click="handleFull"
            ></i>
        </template>
        <el-form :model="form" ref="form" label-width="80px">
            <el-form-item label="分组名称:" required>
                <el-input v-model="form.name" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="父级节点:">
                <el-select v-model="parentsValue" placeholder="请选择">
                    <el-option
                        v-for="item in parents"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                        <div :style="{ 'text-indent': item.depth + 'em' }">
                            {{ item.name }}
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分组描述:">
                <el-input type="textarea" v-model="form.summary"></el-input>
            </el-form-item>
            <el-form-item label="API授权:" required class="auth-box">
                <div v-for="(item, index) in this.authsData" :key="index">
                    <el-checkbox
                        :indeterminate="item.indeterminate"
                        v-model="item.checkAll"
                        @change="handleCheckAllChange($event, item)"
                    >
                        <span class="group">{{ item.group }} </span>
                    </el-checkbox>
                    <p>
                        <el-checkbox-group
                            v-model="item.values"
                            @change="handleCheckedAuthChange($event, item)"
                        >
                            <el-checkbox
                                v-for="(auth, index) in item.list"
                                :key="index"
                                :label="auth.value"
                                :disabled="auth.disabled"
                            >
                                {{ auth.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </p>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="handleCancel">取消</el-button>
        </template>
    </el-dialog>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { getParentAuths, getAuthsData } from '../../../../api/main/api-auths'
// eslint-disable-next-line no-unused-vars
import { addGroup, editGroup } from '../../../../api/main/api-groups'
export default {
    data() {
        return {
            parents: [],
            parentsValue: null,
            authsData: [],
            form: this.groupData,
            fullscreen: false
        }
    },
    props: {
        groupData: {
            type: Object
        }
    },
    watch: {
        parentsValue(newVal, oldVal) {
            this.form.pid = newVal
            this.fetchAuths()
        }
    },
    created() {
        // 仅首次调用
        this.fetchParents()
        this.fetchAuths()
    },
    methods: {
        fetchParents() {
            getParentAuths(this.form.id).then(res => {
                if (res.code === 0) {
                    this.parents = res.data
                    this.parentsValue = this.form.pid
                }
            })
        },
        fetchAuths() {
            getAuthsData(this.form.pid, this.form.id).then(res => {
                if (res.code === 0) {
                    this.authsData = []
                    res.data.forEach(item => {
                        var checkedCount = item.authList.filter(a => a.checked).length
                        this.authsData.push({
                            group: item.group,
                            list: item.authList.map(au => {
                                return {
                                    name: au.name.replace(item.group + '/', ''),
                                    value: au.value,
                                    checked: au.checked,
                                    disabled: au.disabled
                                }
                            }),
                            values: item.authList.filter(it => it.checked).map(au => au.value),
                            checkAll: checkedCount === item.authList.length,
                            indeterminate: checkedCount > 0 && checkedCount < item.authList.length
                        })
                    })
                }
            })
        },
        handleFull() {
            this.fullscreen = !this.fullscreen
        },
        handleCancel() {
            this.$emit('hide')
        },
        handleCheckAllChange(val, item) {
            item.values = val ? item.list.map(it => it.value) : []
            item.indeterminate = false
        },
        handleCheckedAuthChange(val, item) {
            let checkedCount = item.values.length
            item.checkAll = checkedCount === item.list.length
            item.indeterminate = checkedCount > 0 && checkedCount < item.list.length
        },
        submitForm() {
            let vArry = []
            this.authsData
                .map(it => it.values)
                .forEach(p => {
                    vArry = vArry.concat(p)
                })
            this.form.value = vArry.join(',')
            if (this.form.name.trim() === '') {
                this.$message.error('请输入分组名称')
            } else if (this.form.value.trim() === '') {
                this.$message.error('请至少选择一个授权')
            } else {
                if (this.form.id === 0) {
                    // 添加分组
                    addGroup(this.form).then(res => {
                        if (res.code === 0) {
                            // 刷新授权列表
                            this.$emit('refresh')
                            this.$confirm('添加分组成功,是否继续添加?', '提示', {
                                confirmButtonText: '添加',
                                cancelButtonText: '取消',
                                type: 'success',
                                lockScroll: false
                            })
                                .then(() => {
                                    this.form.name = ''
                                    this.form.summary = ''
                                    this.fetchParents()
                                    this.fetchAuths()
                                })
                                .catch(() => {
                                    this.handleCancel()
                                })
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    // 编辑分组
                    editGroup(this.form).then(res => {
                        if (res.code === 0) {
                            // 刷新授权列表
                            this.$emit('refresh')
                            this.$confirm('编辑分组成功,是否调整?', '提示', {
                                confirmButtonText: '调整',
                                cancelButtonText: '取消',
                                type: 'success',
                                lockScroll: false
                            }).catch(() => {
                                this.handleCancel()
                            })
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            }
        }
    }
}
</script>
<style lang="less">
.custom-dialog {
    .el-dialog__header {
        padding: 20px 30px 5px;
    }
    .el-dialog__body {
        padding: 10px 30px 5px 30px;
    }
    .el-dialog__footer {
        padding: 20px 30px;
    }
    .el-form-item {
        margin-bottom: 15px;
    }
    .auth-box {
        span.group {
            font-weight: bold;
        }
        p {
            padding: 0;
            margin: 0;
        }
    }
}
.full-screen {
    position: absolute;
    top: 20px;
    right: 45px;
    cursor: pointer;
    font-size: 14px;
    color: #555555;
    &:hover {
        color: #1c99ff;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/security/auth/group.vue